'use client'

import { useLanguage } from '@/lib/i18n/LanguageContext'
import { Button } from '@/components/ui/button'

interface EmailTypoPromptProps {
  typed: string
  suggestion: string
  onUseSuggestion: () => void
  onKeepTyped: () => void
}

/**
 * Shown instead of sending when the domain looks misspelled
 * (src/lib/auth/emailTypo.ts). One tap fixes and sends; the other sends to
 * the address exactly as typed.
 */
export default function EmailTypoPrompt({ typed, suggestion, onUseSuggestion, onKeepTyped }: EmailTypoPromptProps) {
  const { t } = useLanguage()
  const [before, after] = t('authModal.typoQuestion').split('{email}')

  return (
    <div role="alert" className="p-3 bg-amber-50 border border-amber-200 rounded-lg space-y-3">
      <p className="text-sm text-amber-900">
        {before}
        <strong className="[overflow-wrap:anywhere]">{suggestion}</strong>
        {after}
      </p>
      <div className="flex flex-col gap-2">
        <Button type="button" className="w-full" onClick={onUseSuggestion}>
          {t('authModal.typoUseFix')}
        </Button>
        <Button type="button" variant="outline" className="w-full h-auto whitespace-normal [overflow-wrap:anywhere]" onClick={onKeepTyped}>
          {t('authModal.typoKeep').replace('{email}', typed)}
        </Button>
      </div>
    </div>
  )
}
